<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button type="primary" v-if="hasAdd" @click="$router.push('/supplierPayment/add')">新增</el-button>
      </template>
      <el-form inline ref="searchForm" class="global-form-label-width">

        <el-form-item prop="userId" label="供应商">
          <el-select v-model="searchForm.userId" clearable filterable placeholder="请选择供应商">
            <el-option v-for="(item, index) of gysArr" :value="item.userId" :label="item.userName"
              :key="index"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="purchaseType" label="付款类型">
          <el-select v-model="searchForm.purchaseType" clearable filterable placeholder="请选择付款类型">
            <el-option v-for="(item, index) of typeArr" :value="item.value" :label="item.label"
              :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="purchaseDate" label="付款日期">
          <el-date-picker v-model="searchForm.purchaseDate" placeholder="请选择付款日期" type="date" clearable
            format="yyyy-MM-dd" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card class="mt10" shadow="never">
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column show-overflow-tooltip min-width="100" label="订单ID" prop="orderId"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="100" label="提货单ID" prop="deliveryId"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="100" label="供应商" prop="supplierName"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="付款类型" prop="purchaseType">
          <template v-slot="{ row }">
            <span v-if="row.purchaseType == '1'">保证金</span>
            <span v-if="row.purchaseType == '2'">货款</span>
            <span v-if="row.purchaseType == '3'">运费</span>

          </template>

        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="付款金额" prop="purchasePrice">

        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="付款日期" prop="purchaseDate"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="备注说明" prop="remark"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="创建时间" prop="ctime">

        </el-table-column>

        <el-table-column fixed="right" label="操作" width="160">
          <template v-slot="{ row }">
            <el-button type="text"
              @click="$router.push('/supplierPayment/detail?priceId=' + row.priceId)">详情</el-button>
            <el-button type="text" v-if="hasEdit"
              @click="$router.push('/supplierPayment/edit?priceId=' + row.priceId)">编辑</el-button>

            <el-button type="text" v-if="hasDel" @click="deleteRow(row.priceId)" class="del-btn">删除</el-button>

          </template>
        </el-table-column>
      </el-table>

      <el-pagination :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
        @current-change="loadData">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>

export default {
  name: 'supplierPayment',

  data () {
    return {
      page: 1,
      total: 0,
      tableData: [],
      loading: false,
      searchForm: {
        userId: null,
        purchaseType: null,
        purchaseDate: null
      },
      gysArr: [],
      supplierArr: [],
      typeArr: [
        {
          label: '保证金',
          value: '1'
        },
        {
          label: '货款',
          value: '2'
        },
        {
          label: '运费',
          value: '3'
        }

      ]

    }
  },
  computed: {
    buttonList () {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasAdd () {
      return this.buttonList.includes('add')
    },
    hasEdit () {
      return this.buttonList.includes('edit')
    },
    hasDel () {
      return this.buttonList.includes('delete')
    },
    userId() {
      return this.$route.query.userId
    }
  },

  created () {
    if (this.userId) {
      this.searchForm.userId = this.userId
    }
    this.loadGys()
    this.loadData()
  },
  methods: {
    loadGys () {
      this.$axios.get(this.$apis.common.selectIparkUserByList, { userType: '4' }).then(res => {
        this.gysArr = res || []
      })
    },

    loadData () {
      this.loading = true
      this.$axios.get(this.$apis.supplierPayment.selectYcSupplierPriceByPage, {
        params: {
          page: this.page,
          ...this.searchForm
        }
      }).then(res => {
        this.tableData = res.list || []
        this.total = res.total || 0
      }).finally(() => {
        this.loading = false
      })
    },

    onSearch () {
      this.page = 1
      this.loadData()
    },
    resetForm () {
      this.$refs.searchForm.resetFields()
      this.searchForm = {
        purchaseType: null,
        userId: null,
        purchaseDate: null

      }
      this.onSearch()
    },
    deleteRow (priceId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.supplierPayment.deleteDataYcSupplierPrice, {
          priceId
        }).then(() => {
          this.loadData()
        })
      })
    }

  }
}
</script>

<style scoped lang='scss'>
.btn {
  text-decoration: underline;
  color: #007bff;
  cursor: pointer;
}
</style>
